import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocTeamAlertIssueSyncingRoute } from '@jira/router-routes__eoc-alert-issue-syncing-routes/src/eocTeamAlertIssueSyncingRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as alertIssueSyncingResources } from '@atlassian/eoc-alert-issue-syncing/resources';
import type { Route } from '@atlassian/react-resource-router';
import { AlertIssueSync } from './ui/AlertIssueSync.tsx';
import { LazyAlertIssueSync } from './ui/async.tsx';

export const eocTeamAlertIssueSyncingRouteEntry: Route = createEntry(
	eocTeamAlertIssueSyncingRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: AlertIssueSync,
		layout: opsTeamLayout,
		slot: null,
		basePath: '/jira/ops/teams',

		resources: [
			...getNavigationResources(),
			...teamDashboardResources(),
			getConsolidationStateResource(),
			alertIssueSyncingResources.configuredSyncsResource,
			alertIssueSyncingResources.userAccessRightsResource,
		],

		navigation: {
			menuId: MenuIdPeople,
			horizontal: AsyncHorizontalOperationsNav,
		},

		forPaint: [
			LazyHorizontalOperationsNav,
			LazyAtlassianNavigation,
			LazyAlertIssueSync,
			LazyTeamDashboardSidebar,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
